



export function langUrl (url) {
    if (!window.sLanguage || window.sLanguage === 'nl') return url;
    return '/'+ window.sLanguage + url;
}

export function fullUrl (url) {
    return `${window.location.protocol}//${window.location.host}` + langUrl('/'+url);
}
